import { useQuery } from '@tanstack/react-query';
import { GlobalQueryKeys, UserQueryKeys } from '@enums/react-query-keys';
import { WelcomeVoucher } from '@interfaces/models/welcomeVoucher';
import useUser from '@hooks/user/use-user';
import { getWelcomeVoucherForCurrentlyAuthenticatedUser } from '@api/authenticated-user';
import { TouchPoint } from '@interfaces/common/common';
import { AppCookies } from '@enums/cookies';
import Cookies from 'universal-cookie';

const useWelcomeVoucherQuery = (touchPoint: TouchPoint = 'REGISTER_SCREEN') => {
  const { user, isAuthenticated } = useUser();
  const newCookieInstance = new Cookies();
  const clientAnonymousId = newCookieInstance.get<string>(AppCookies.ANONYMOUS_USER_ID_CSR);

  const { data: anonymousUserWelcomeVoucher } = useQuery<WelcomeVoucher>({
    queryKey: [GlobalQueryKeys.WELCOME_VOUCHER_ANONYMOUS_USER, touchPoint],
    enabled: !isAuthenticated,
    staleTime: Infinity,
    placeholderData: null,
  });

  const { data: loggedInUserWelcomeVoucher } = useQuery<WelcomeVoucher>({
    queryKey: [UserQueryKeys.WELCOME_VOUCHER_LOGGED_IN_USER, user?.id, touchPoint],
    queryFn: () => getWelcomeVoucherForCurrentlyAuthenticatedUser(touchPoint, clientAnonymousId),
    enabled: isAuthenticated,
    staleTime: Infinity,
    placeholderData: null,
  });

  const welcomeVoucher = isAuthenticated ? loggedInUserWelcomeVoucher : anonymousUserWelcomeVoucher;

  return {
    welcomeVoucher,
  };
};

export default useWelcomeVoucherQuery;
